import { useState, useEffect, useCallback } from "react";
import { Task } from "@/features/login/types";
import { useAlgorithmStore } from "./useGennie";
import { algorithmService } from "../../algorithm/services/api";

interface UseTaskListReturn {
  tasks: Task[];
  total: number;
  loading: boolean;
  error: string | null;
  refetch: () => void;
}

export const useTaskList = (): UseTaskListReturn => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const { tasks, setTasks } = useAlgorithmStore();

  const fetch = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const result = await algorithmService.getTaskList();

      setTasks(result, result.length);
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : "Failed to load tasks");
    } finally {
      setLoading(false);
    }
  }, [setTasks]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return {
    tasks,
    total: tasks.length, // ✅ derive langsung
    loading,
    error,
    refetch: fetch,
  };
};
